export default __webpack_public_path__ + "static/fire-rash-8cdd92f93592bc61875634cc90dd146e.png";